<div class="flex items-center justify-center">
  <ng-container *ngIf="!formAberto">
    <button type="button" class="w-80 btn btn--secondary mr-5" (click)="formAberto = true">Cadastrar Nova</button>
  </ng-container>

  <button
    *ngIf="formAberto"
    type="button"
    class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto"
    (click)="formAberto = false"
  >
    X
  </button>
</div>
<ng-container *ngIf="formAberto">
  <h1 class="text-lg font-bold leading-3">CADASTRAR NOVA ABA NO DASHBOARD</h1>
  <small class="text-xs text-chathams-blue">Insira os dados abaixo para cadastrar</small>

  <form class="grid grid-cols-4 gap-5" [formGroup]="form" (ngSubmit)="salvarDashboard()">
    <input type="text" class="form-input" placeholder="Nome da Aba" formControlName="tabName" />
    <input type="number" class="form-input" placeholder="Número no Metabase" formControlName="dashboardNumber" />

    <ng-select
      notFoundText="Nenhum item encontrado"
      [items]="opcoesCompany"
      [searchable]="true"
      placeholder="Empresa"
      formControlName="companyId"
      bindLabel="name"
      bindValue="id"
      [multiple]="false"
    >
    </ng-select>

    <button type="submit" class="h-9 btn btn--secondary">Cadastrar Nova</button>
  </form>
</ng-container>
